/**
 * @fileoverview Agent definition for short-story-modifier-v1.
 *
 * Takes a natural language change request from the author and applies
 * modifications across plot threads, character arcs, and writtenPlot
 * for short-form fiction. The writtenPlot is the single source of truth.
 * Results are shown for user confirmation before persisting (Tier 2).
 *
 * @category narrative.story.planning
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'short-story-modifier-v1',
  kind: 'primitive',
  name: 'Story Modifier (Short-Form)',
  description: 'Applies natural language change requests across plot threads, character arcs, and writtenPlot for short-form fiction. No storylines or beats — writtenPlot is the single source of truth. Returns proposed changes with commentary for user confirmation before persisting.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'narrative.story.planning',
    usedBy: [
      'primitives/use-short-story-modifier-v1.ts',
    ],
    relatedAgents: [
      'short-story-planner-v4',
      'story-modifier-v1',
      'single-chapter-story-generator-v2',
    ],
  },
  recommendedModels: [
    { modelProvider: 'google-ai', modelName: 'gemini-3.1-pro-preview' },
    { modelProvider: 'anthropic', modelName: 'claude-sonnet-4-5' },
    { modelProvider: 'openai', modelName: 'gpt-5.2' },
  ],
};
